import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { Store } from 'vuex'

export class Journal extends Model {
	protected jsonApiType = 'accounting/journals'

	@Property()
	public code!: string

	@Property()
	public description!: string

	public static async fetchAllLazy(store?: Store<any>): Promise<Array<Journal>> {
		if (!store) {
			store = (await import('@/store/index')).store
		}
		if (!store.getters['accountingJournals/hasAllFetched']()) {
			await store.dispatch('accountingJournals/findAll')
		}

		return store.getters['accountingJournals/peekAll']()
	}

	public static async fetchLazy(id): Promise<Journal> {
		const store = (await import('@/store/index')).store
		if (!store.getters['accountingJournals/hasCached'](id)) {
			await store.dispatch('accountingJournals/findRecord', id)
		}

		return store.getters['accountingJournals/peekRecord'](id)
	}
}
